
// loads asset folders and build media/[folder] path in the built assets (for images, svg, fonts)
const assets = require.context('/app/frontend/assets/showcase', true);
const assetsPath = (name) => assets(name, true);

import('./application.css')
import('/app/frontend/javascript/showcase/index.js')
